import { useCallback, useEffect, useState } from "react"
import { getImageryLayer } from "../map/layers/ImageryLayers"
import { ImageryProperties } from "./types"

import * as reactiveUtils from "@arcgis/core/core/reactiveUtils"
import { getView } from "../map"



export const useImagery = (layerId: string): ImageryProperties => {
  const layer = getImageryLayer(layerId)
  const [isVisible, setVisible] = useState<boolean>((layer && layer.visible) || false)
  const [opacity, setOpacity] = useState<number>((layer && layer.opacity * 100) || 0)
  const [isUpdating, setUpdating] = useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [retryCount, setRetryInit] = useState<number>(0)

  useEffect(() => {
    if (layer) {
      const trackUpdating = async () => {
        const view = getView()
        if (!view) {
          setTimeout(trackUpdating, 1000)
          return
        }
        const layerView = await view.whenLayerView(layer)
        reactiveUtils.watch(() => layerView.updating, (isUpdating: boolean) => {
          setUpdating(isUpdating)
        })
      }
      trackUpdating()
    } else {
      setTimeout(() => {
        setRetryInit(initCount => initCount + 1)
      }, 500)
    }
  }, [layer])

  const toggle = useCallback(() => {
    if (layer) {
      layer.visible = !layer.visible
      setVisible(layer.visible)
    }
  }, [layer])

  const updateOpacity = useCallback((opacity: number) => {
    if (layer) {
      setOpacity(opacity)
      layer.opacity = opacity / 100.0
    }
  }, [layer])


  return {
    id: layerId,
    opacity,
    isVisible,
    isUpdating,
    actions: {
      toggle,
      updateOpacity,
    }
  }
}



export const toggleImagery = (layerId: string) => {
  const layer = getImageryLayer(layerId)
  if (layer) {
    layer.visible = !layer.visible
  }
}

export const setOpacity = (layerId: string, opacity: number) => {
  const layer = getImageryLayer(layerId)
  if (layer) {
    layer.opacity = opacity
  }
}